import WithRender from "../../templates/base/pdfDieCut.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getCostCenter"]),
    name: () => {
      return "Cost Center Number:";
    },
    costCenter: {
      get: function () {
        return this.getCostCenter;
      },
      set: function (newValue) {
        this.setCostCenter(newValue);
      }
    }
  },
  methods: {
    ...mapActions(["setCostCenter"])
  }
});
